import { SelectOption } from '@globaleris/ui.library'
import { EnumEstadoViajeOpLogistica } from '../../api/oData/enums/enumEstadoViajeOpLogistica'
import Tanks, {
  Carrier,
  Destiny,
  DestinyPlant,
  TankClient,
  TankOriginPlant
} from '../../api/Pioneer/model/Tanks'
import { enumKeyToValue, enumValueToKey, enumEnumToValueNumber } from '../../helpers'
import { getActiveBalanceZone, getActiveCompany } from '../../redux'
import {
  TankModel,
  CarrierTableModel,
  DestinyModel,
  DestinyPlantModel,
  DestinationTableModel,
  TankClientModel,
  TankOriginPlantModel,
  TankShipment,
  DataFormModel,
  MassiveDispatchRequest,
  TankIdValue,
  TankModelPatch,
  FetchTankOpsToDispatchRequest,
  DefaultCosts,
  DefaultCost
} from './tanks.model'
import { DateTime } from 'luxon'
import moment from 'moment'
import { EnumDispatchType } from '../../api'
import { getGasDay } from '../../helpers/gasDayHelper'
import { getGlobalActionsConfiguration } from '../regulatoryReports'
import {
  canEdit,
  canSend,
  canOnlyView,
  canEditQuantity,
  canCancel,
  canDelete
} from './tanks.helpers'
import { DEFAULT_NOT_FULL_TANK_QUANTITY } from './tanks.constants'
import { EnumTipoCosteCisternas } from '../../api/oData/enums/enumTipoCosteCisternas'

export const tanksListItemsMapper = (items: Tanks[]): TankModel[] => {
  return items && items.map(tanksListItemMapper)
}
export const tanksListItemMapper = (item: Tanks): TankModel => {
  const date = item?.tripDate ? new Date(item?.tripDate) : null

  return (
    item && {
      id: item.id,
      orderDate: item.orderDate,
      tripDate: !date || date?.getFullYear() === 1 ? undefined : item.tripDate, //item.tripDate,
      tsoCode: item.tsoCode,
      client: clientItemMapper(item.client),
      originPlant: originPlantItemMapper(item.originPlant),
      destinations: item.destinations.map(e => e.destinyPlant.id),
      quantity: item.quantity,
      kg: item.kg,
      orderKg: item.orderKg,
      orderQuantity: item.orderQuantity,
      pcs: item.pcs,
      carriers: item.carriers.map(e => e.carrierId),
      tankOperation: item.tankOperation,
      deliveryNote: item.deliveryNote,
      tripState: enumKeyToValue(EnumEstadoViajeOpLogistica, item.tripState),
      managedTripState: enumEnumToValueNumber(EnumEstadoViajeOpLogistica, item.managedTripState),
      dischargeDate: item.dischargeDate ?? undefined,
      canCancel: canCancel(
        enumKeyToValue(EnumEstadoViajeOpLogistica, item.tripState),
        item.tripDate!
      ),
      canEdit: canEdit(enumKeyToValue(EnumEstadoViajeOpLogistica, item.tripState), item.tripDate),
      canSend:
        canSend(enumKeyToValue(EnumEstadoViajeOpLogistica, item.tripState)) &&
        item.tripDate !== undefined &&
        moment(item.tripDate!).endOf('day').toDate() >= getGasDay(),
      onlyView: item.tripState
        ? canOnlyView(enumKeyToValue(EnumEstadoViajeOpLogistica, item.tripState), item.tripDate!)
        : false,
      canEditQuantity: item.tripState
        ? canEditQuantity(enumKeyToValue(EnumEstadoViajeOpLogistica, item.tripState), item.tripDate)
        : false,
      canDelete: canDelete(enumKeyToValue(EnumEstadoViajeOpLogistica, item.tripState)),
      actionsConfiguration: getGlobalActionsConfiguration(),
      actions: item.actions,
      checkCompleted: item.quantity ? item.quantity !== DEFAULT_NOT_FULL_TANK_QUANTITY : false
    }
  )
}

export const clientItemMapper = (item: TankClient | undefined): TankClientModel | undefined => {
  return (
    item && {
      id: item.id,
      description: item.description
    }
  )
}
export const originPlantItemMapper = (
  item: TankOriginPlant | undefined
): TankOriginPlantModel | undefined => {
  return (
    item && {
      id: item.id,
      description: item.description
    }
  )
}

export const listDestinationItemMapper = (items: Destiny[]): DestinyModel[] => {
  return items && items.map(destinationItemMapper)
}

export const destinationItemMapper = (item: Destiny): DestinyModel => {
  return (
    item && {
      id: item.id,
      destinyPlant: destinyPlantMapper(item.destinyPlant),
      percentage: item.percentage
    }
  )
}

export const listCarriertemMapper = (items: any[]): SelectOption[] => {
  return items && items.map(carrierItemMapper)
}

export const carrierItemMapper = (item: any): SelectOption => {
  return (
    item && {
      value: item.value,
      label: item.label
    }
  )
}

export const listDestinyMapper = (items: Destiny[]): SelectOption[] => {
  return items && items.map(destinyItemMapper)
}

export const destinyItemMapper = (item: Destiny): SelectOption => {
  return (
    item && {
      value: item.destinyPlant.id,
      label: item.destinyPlant.description
    }
  )
}

export const destinyPlantMapper = (item: DestinyPlant): DestinyPlantModel => {
  return (
    item && {
      id: item.id,
      description: item.description
    }
  )
}

export const mapGetTanksSize = (items: any[]): SelectOption[] => {
  return items && items.map(itemsGetTanksSize)
}

export const itemsGetTanksSize = (item: any): SelectOption => {
  return (
    item && {
      label: item.nmSizeTruck.toString(),
      value: item.idSizeTruck
    }
  )
}

export const mapGetOriginPlants = (items: any[]): SelectOption[] => {
  return items && items.map(itemsOriginPlants)
}

export const itemsOriginPlants = (item: any): SelectOption => {
  return (
    item && {
      label: item.label.toString(),
      value: item.value
    }
  )
}
export const mapGetDestinations = (items: any[]): SelectOption[] => {
  return items && items.map(itemsDestinations)
}

export const itemsDestinations = (item: any): SelectOption => {
  return (
    item && {
      label: item.label.toString(),
      value: item.value
    }
  )
}
export const mapGetCarriers = (items: any[]): SelectOption[] => {
  return items && items.map(itemsCarriers)
}

export const itemsCarriers = (item: any): SelectOption => {
  return (
    item && {
      value: item.value,
      label: item.label
    }
  )
}
export const mapperOnSaveCarriersTable = (
  item: CarrierTableModel,
  carriers: SelectOption[]
): CarrierTableModel => {
  return (
    item && {
      carrierTripId: item.carrierTripId,
      carrierId: item.carrierId,
      quantity: item.quantity,
      description: carriers.find(x => x.value === item.carrierId)?.label,
      costType: item.costType,
      lgmaster: item.lgmaster,
      canDelete: true,
      reactId: item.reactId
    }
  )
}

export const mapGetCarrierSelected = (item: any): CarrierTableModel => {
  return (
    item && {
      carrierTripId: item.value,
      carrierId: item.value,
      description: item.label,
      quantity: 0,
      costType: undefined,
      lgmaster: true,
      canDelete: false,
      reactId: item.reactId
    }
  )
}

export const mapGetDestinationSelected = (item: any): DestinationTableModel => {
  return (
    item && {
      id: item.value,
      destinationId: item.value,
      description: item.label,
      percentage: 100,
      canDelete: true
    }
  )
}

export const mapGetClients = (items: any[]): SelectOption[] => {
  return items && items.map(itemsClients)
}

export const itemsClients = (item: any): SelectOption => {
  return (
    item && {
      label: item.label.toString(),
      value: item.value
    }
  )
}
export const mapGetDestinationsTable = (items: any[]): SelectOption[] => {
  return items && items.map(itemsDestinationsTable)
}

export const itemsDestinationsTable = (item: any): SelectOption => {
  return (
    item && {
      value: item.value,
      label: item.label
    }
  )
}

export const mapCostTypesList = (items: any[]): SelectOption[] => {
  return items && items.map(mapCostTypes)
}

export const mapCostTypes = (item: any): SelectOption => {
  return (
    item && {
      label: item.label.toString(),
      value: item.value
    }
  )
}

export const mapperOnSaveDestinationsTable = (
  item: DestinationTableModel,
  destinations: SelectOption[]
): DestinationTableModel => {
  return (
    item && {
      id: item.id,
      destinationId: item.destinationId,
      percentage: item.percentage,
      description: destinations.find(x => x.value === item.destinationId)?.label,
      canDelete: true
    }
  )
}

export const tankShipmentMapper = (
  formData: DataFormModel,
  destinationData: DestinationTableModel[],
  carriersData: CarrierTableModel[],
  tank?: any,
  newState?: EnumEstadoViajeOpLogistica
  //validate?: boolean,
): TankShipment => {
  return (
    formData &&
    destinationData &&
    carriersData && {
      tankId: tank?.id,
      tripDate: formData.chargeDate ? moment(formData.chargeDate).format('YYYY-MM-DD') : undefined,
      tripState: newState,
      dischargeDate: formData.dischargeDate
        ? moment(formData.dischargeDate).format('YYYY-MM-DD')
        : undefined,
      ownerId: formData?.client?.value ? +formData.client.value : 0,
      tankQuantityKg: formData.kg,
      tankQuantityPCS: formData.pcs,
      tankQuantity:
        typeof formData.quantityOption !== 'string' ? formData.quantityOption?.label : '',
      originPlantId: formData?.originPlant?.value ? +formData.originPlant.value : undefined,
      tankDestiniesList: tankDestinationsListItemMapper(destinationData),
      carrierList: carriersListMapper(carriersData, formData),
      deliveryNote: formData.deliveryNote,
      company: getActiveCompany()?.id,
      balanceZone: getActiveBalanceZone()?.id,
      orderDate: formData.orderDate ? moment(formData.orderDate).format('YYYY-MM-DD') : undefined,
      orderQuantity: formData.orderQuantity,
      orderKg: formData.orderKg,
      comments: formData.comments
    }
  )
}

export const tankShipmentMapperPatch = (tank: Tanks, data: TankModelPatch): TankShipment => {
  return {
    tankId: tank?.id,
    tripDate: moment(tank.tripDate).format('YYYY-MM-DD'),
    tripState:
      tank && tank.tripState
        ? enumValueToKey(EnumEstadoViajeOpLogistica, tank.tripState)
        : undefined,
    dischargeDate: data.dischargeDate
      ? moment(data.dischargeDate).format('YYYY-MM-DD')
      : tank.dischargeDate
        ? moment(tank.dischargeDate).format('YYYY-MM-DD')
        : undefined,
    ownerId: tank?.client?.id,
    tankQuantityKg: data.kg ?? tank.kg,
    tankQuantityPCS: data.pcs ?? tank.pcs,
    originPlantId: tank?.originPlant?.id,
    tankDestiniesList: tank.destinations,
    carrierList: tank.carriers,
    deliveryNote: data.deliveryNote ?? tank.deliveryNote,
    company: getActiveCompany()?.id,
    balanceZone: getActiveBalanceZone()?.id,

    tankQuantity: `${data.quantity ?? tank.quantity}`
  }
}

export const tankDestinationsListItemMapper = (items: DestinationTableModel[]): Destiny[] => {
  return items && items.map(destinationsListItemMapper)
}

export const destinationsListItemMapper = (item: DestinationTableModel): Destiny => {
  return (
    item && {
      id: item.id,
      destinyPlant: destinyPlantItemMapper(item),
      percentage: item.percentage
    }
  )
}
export const destinyPlantItemMapper = (item: DestinationTableModel): DestinyPlant => {
  return (
    item && {
      id: item.destinationId,
      description: item.description ?? ''
    }
  )
}

export const carriersListMapper = (items: any[], formData: any): Carrier[] => {
  return items && items.map(item => carriersListItemMapper(item, formData))
}

export const carriersListItemMapper = (item: CarrierTableModel, formData: any): Carrier => {
  return (
    item && {
      carrierTripId: item.carrierTripId,
      carrierId: item.carrierId,
      amount: item.quantity ?? null,
      carrierDescription: item.description ?? '',
      costType: item.costType,
      lgMaster: item.lgmaster
    }
  )
}

export const tankListItemsSendMapper = (items: any[]): TankModel[] => {
  return items && items.map(tankListItemSendMapper)
}
export const tankListItemSendMapper = (item: any): TankModel => {
  return (
    item && {
      id: item.id,
      tripDate: item.tripDate,
      tsoCode: item.tsoCode,
      client: clientItemMapper(item.client),
      originPlant: originPlantItemMapper(item.originPlant),
      destinations: [],
      quantity: item.quantity,
      kg: item.kg,
      pcs: item.pcs,
      carriers: [],
      tankOperation: item.tankOperation,
      deliveryNote: item.deliveryNote,
      tripState: enumKeyToValue(EnumEstadoViajeOpLogistica, item.tripState),
      canCancel: canCancel(
        enumKeyToValue(EnumEstadoViajeOpLogistica, item.tripState),
        item.tripDate!
      ),
      canEdit: canEdit(enumKeyToValue(EnumEstadoViajeOpLogistica, item.tripState), item.tripState),
      canEditQuantity: canEditQuantity(
        enumKeyToValue(EnumEstadoViajeOpLogistica, item.tripState),
        item.tripState
      ),
      canSend:
        canSend(enumKeyToValue(EnumEstadoViajeOpLogistica, item.tripState)) &&
        item.tripDate !== undefined &&
        moment(item.tripDate!).toDate() >= moment().toDate(),
      onlyView: canOnlyView(item.tripState, item.tripDate!),
      canDelete: canDelete(enumKeyToValue(EnumEstadoViajeOpLogistica, item.tripState)),
      actionsConfiguration: getGlobalActionsConfiguration(),
      actions: item.actions
    }
  )
}

export const sendMassiveDispatchesMapper = (items: any[]): TankIdValue[] => {
  return items.map(item => ({
    id: item.id,
    operationType: item.tipoOperacion,
    balanceZone: item.zonaBalance
  }))
}

export const tankMapperToAPI_Send = (items: any[]): MassiveDispatchRequest => {
  return (
    items && {
      dispatchType: enumValueToKey(EnumDispatchType, EnumDispatchType.Nominacion),
      companyID: getActiveCompany()?.id,
      operations: items.map((item: any) => {
        return {
          id: item.id,
          operationType: item.tipoOperacion,
          balanceZone: getActiveBalanceZone()?.code!
        }
      })
    }
  )
}

export const destinationsToDestinationTableModel = (
  destinations: Destiny[]
): DestinationTableModel[] => {
  return destinations.map(d => ({
    id: d.id,
    destinationId: d.destinyPlant.id,
    percentage: d.percentage!,
    description: d.destinyPlant.description,
    canDelete: false
  }))
}

export const getTanksIds = (items: TankModel[]): number[] => {
  return items && items.map(item => item.id ?? 0)
}

export const getOpsIds = (items: TankModel[]): number[] => {
  return items && items.map(item => item.tankOperation?.id ?? 0)
}

export const mapTanksDataToDataTable = (tanks: TankModel[] | undefined): TankModel[] => {
  if (tanks) {
    return tanks.map(tank => mapTankDataToDataTable(tank))
  }
  return []
}

export const mapTankDataToDataTable = (tank: TankModel): TankModel => {
  return {
    ...tank,
    ...(tank.originPlant?.id && { originPlantId: [tank.originPlant.id] })
  }
}

export const mapOriginPlantsFromFetchedTanksArray = (
  tanks: TankModel[] | undefined
): SelectOption[] => {
  if (!tanks || tanks.length === 0) {
    return []
  }

  let uniqueOptions = new Map<string, SelectOption>()

  tanks.forEach(tank => {
    const mappedValue = mapOriginPlantsFromFetchedTank(tank)
    if (mappedValue) {
      uniqueOptions.set(mappedValue.value.toString(), mappedValue) // Si el valor ya existe, no se sobrescribe
    }
  })

  return Array.from(uniqueOptions.values()) // Convierte el Map en un array limpio para que se pueda usar en el multiselect
}

export const mapOriginPlantsFromFetchedTank = (tank: TankModel): SelectOption | undefined => {
  if (tank.originPlant?.id && tank.originPlant?.description) {
    return {
      value: tank.originPlant.id,
      label: tank.originPlant.description
    }
  }
}

export const defaultCostsMapper = (items: any[]): DefaultCosts[] => {
  return items && items.map(defaultCostMapper)
}

export const defaultCostMapper = (item: any): DefaultCosts => {
  return (
    item && {
      originPlantId: item.originPlantId,
      deliveryId: item.deliveryId,
      destiniesIds: item.destiniesIds,
      costs: costListItemMapper(item.costs)
    }
  )
}

export const costListItemMapper = (items: any[]): DefaultCost[] => {
  return items && items.map(costMapper)
}

export const costMapper = (item: any): DefaultCost => {
  return (
    item && {
      quantity: item.cost,
      costType: enumValueToKey(EnumTipoCosteCisternas, item.costType) // item.costType
    }
  )
}
